import React, {useEffect, useMemo, useState} from 'react';

import {useStore} from 'effector-react';
import debounce from 'lodash/debounce';

import {useTranslation} from 'react-i18next';

import {ReactComponent as ClearIcon} from 'assets/svg/cross.svg';
import {Input} from 'components/ui-kit/Input';
import {search$, searchChanged} from 'models/documents/documents/grid/table';

import {CancelIcon} from './styled';

export const TableSearch = () => {
    const {t} = useTranslation();
    const search = useStore(search$);
    const [value, setValue] = useState(search);

    useEffect(() => {
        setValue(search);
    }, [search]);

    const debouncedSearchChanged = useMemo(
        () =>
            debounce((nextValue: string, prevValue: string) => {
                if (nextValue !== prevValue) {
                    searchChanged(nextValue);
                }
            }, 1000),
        [],
    );

    useEffect(() => {
        debouncedSearchChanged(value, search);
        return debouncedSearchChanged.cancel;
    }, [value, search]);

    return (
        <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={t('pages.documents.search')}
            style={{minWidth: 350}}
            adornment={
                <CancelIcon
                    width={10}
                    height={10}
                    source={ClearIcon}
                    onClick={() => setValue('')}
                />
            }
        />
    );
};
